export const isRecruitmentOpen = false;

export const recruitmentAnnouncement = isRecruitmentOpen
  ? "2025/9/25: 新規メンバーの受付を再開しました"
  : "2026/5/25: 新規メンバーの受付を一時停止しました。";

export const joinCtaText = isRecruitmentOpen
  ? "初参加の申し込みはこちらから"
  : "現在、新規募集を停止しています。";
